export default ['Механическая', 'Автоматическая', 'Вариатор', 'Робот']
